import '../../stylesheets/shared/not_found_404.scss';
import illus_error from '../../images/illus_error.svg';
import { useEffect } from 'react';

function NotFound404() {
  useEffect(() => {
    window.location.href = '/';
  }, []);
  return null;
}

export default NotFound404;
